import type { TeaserTrackingInformationProps } from './TeaserTrackingInformationProps';
import sendAtiTag from './sendAtiTag';
export default function sendTeaserClick(pageTitle: string, teaserTrackingInformation: TeaserTrackingInformationProps) {
	const trackingField = 'click';
	sendAtiTag(pageTitle, teaserTrackingInformation, trackingField);
}
